import { render, staticRenderFns } from "./Dash.vue?vue&type=template&id=08d889cc"
import script from "./Dash.vue?vue&type=script&lang=js"
export * from "./Dash.vue?vue&type=script&lang=js"
import style0 from "./Dash.vue?vue&type=style&index=0&id=08d889cc&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d889cc')) {
      api.createRecord('08d889cc', component.options)
    } else {
      api.reload('08d889cc', component.options)
    }
    module.hot.accept("./Dash.vue?vue&type=template&id=08d889cc", function () {
      api.rerender('08d889cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Dash.vue"
export default component.exports